import React, { useState, useEffect } from "react";
import { Navigate, NavLink, Route, Routes } from "react-router-dom";
import {
  RiMenuUnfoldFill,
  RiUser3Line,
  RiShieldKeyholeLine,
  RiFileCopy2Line,
  RiCompasses2Fill,
  RiFileHistoryLine,
  RiLogoutBoxRLine,
} from "react-icons/ri";
import Axios from "../../Axios";
import { useAuthContext } from "../../context/AuthContext";
import Layout from "../../utils/Layouts/Layout/Layout";
import Header from "../../utils/Header/Header";
import Popup from "../../utils/Popup/Popup";
import MenuDrawer from "../../components/Account/MenuDrawer/MenuDrawer";
import Profile from "./Profile";
import ChangePassword from "./ChangePassword";
import MyCourses from "./MyCourses";
import MyExams from "./MyExams";
import MyOrderHistory from "./MyOrderHistory";
import "./account.scss";

const noFile = require("../../assets/no-file.png");

const Account = () => {
  const { authConfig, logoutHandler } = useAuthContext();

  const [userData, setUserData] = useState({});
  const [alertVisible, setAlertVisible] = useState(false);
  const [showToggle, setShowToggle] = useState(false);

  useEffect(() => {
    if (authConfig) {
      Axios.get("/auth/me", authConfig).then((res) => {
        if (res.status === 200) {
          setUserData(res.data);
        }
      });
    }
  }, [authConfig]);

  const getUserRole = () => {
    if (userData?.role_id) {
      let role = "";

      if (userData.role_id === 4) {
        role = "Энгийн";
      } else if (userData.role_id === 5) {
        role = "Ахисан";
      }

      return role;
    }
  };

  const getUserName = () => {
    if (userData?.firstname && userData?.lastname) {
      return `${String(userData.lastname).charAt(0)}. ${userData.firstname}`;
    }
    return "Хэрэглэгч";
  };

  const renderMenu = (inToggle) => {
    return (
      <div className="flex flex-col gap-5 p-4 min-h-[530px]">

        {/* ✅ MOBILE дээр л USER INFO */}
        {inToggle && (
          <div className="flex items-center gap-4 mb-5 border-b pb-4">

            <img
              src={userData?.avatar || noFile}
              className="w-32 h-32 rounded-full object-cover"
            />

            <div>
              <p className="font-semibold text-2xl text-gray-800">
                {getUserName()}
              </p>

              <span className="text-xl text-gray-500">
                Эрхийн төрөл
              </span>

              <div className="mt-1 inline-block px-3 py-1 text-xl rounded-full bg-blue-100 text-blue-600">
                {getUserRole() || "Тодорхойгүй"}
              </div>
            </div>
          </div>
        )}

        {/* MENU ITEMS */}
        <NavLink
          to="/account/profile"
          onClick={() => setShowToggle(false)}
          className={({ isActive }) =>
            `flex items-center gap-3 px-6 py-6 rounded-xl transition
            ${
              isActive
                ? "bg-blue-50 text-blue-600"
                : "text-gray-700 hover:bg-gray-100"
            }`
          }
        >
          <RiUser3Line className="text-lg" />
          <span>Хувийн мэдээлэл</span>
        </NavLink>

        <NavLink to="/account/change-password" onClick={() => setShowToggle(false)} className={({ isActive }) =>
          `flex items-center gap-3 px-6 py-6 rounded-xl transition
          ${isActive ? "bg-blue-50 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`
        }>
          <RiShieldKeyholeLine className="text-lg" />
          <span>Нууц үг солих</span>
        </NavLink>

        <NavLink to="/account/my-courses" onClick={() => setShowToggle(false)} className={({ isActive }) =>
          `flex items-center gap-3 px-6 py-6 rounded-xl transition
          ${isActive ? "bg-blue-50 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`
        }>
          <RiFileCopy2Line className="text-lg" />
          <span>Миний хичээлүүд</span>
        </NavLink>

        <NavLink to="/account/my-exams" onClick={() => setShowToggle(false)} className={({ isActive }) =>
          `flex items-center gap-3 px-6 py-6 rounded-xl transition
          ${isActive ? "bg-blue-50 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`
        }>
          <RiCompasses2Fill className="text-lg" />
          <span>Миний шалгалтууд</span>
        </NavLink>

        <NavLink to="/account/order-history" onClick={() => setShowToggle(false)} className={({ isActive }) =>
          `flex items-center gap-3 px-6 py-6 rounded-xl transition
          ${isActive ? "bg-blue-50 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`
        }>
          <RiFileHistoryLine className="text-lg" />
          <span>Миний захиалгын түүх</span>
        </NavLink>

        {/* ✅ LOGOUT зөв байрлал */}
        <div className="mt-auto pt-4">

          <button
            onClick={() => {
              setAlertVisible(true)
              setShowToggle(false);
            }}
            className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white hover:bg-orange-600 transition"
          >
            <RiLogoutBoxRLine />
            Системээс гарах
          </button>

        </div>

      </div>
    );
  };

  return (
    <Layout>
      <Header onHome={true} />
      <Popup
        visible={alertVisible}
        messageType="alert"
        messageText="Та гарахдаа итгэлтэй байна уу?"
        onOk={logoutHandler}
        onCancel={() => setAlertVisible(false)}
      />

      <div className="account">
        <div className="account--drawerToggle">
          {!showToggle && (
            <div
              onClick={() => setShowToggle(true)}
              className="
                fixed left-4
                top-[90px]
                z-40
                w-14 h-14
                flex items-center justify-center
                rounded-full
                bg-[#150665]/70
                text-white
                shadow-[0_7px_14px_#150664]
                transition-all duration-200
                hover:-translate-y-[2px]
                cursor-pointer
              "
            >
              <RiMenuUnfoldFill />
            </div>
          )}

          <MenuDrawer
            visible={showToggle}
            renderMenu={renderMenu}
            onCancel={() => setShowToggle(false)}
          />
        </div>

        <aside className="account__menu">
          <div className="account__menu-topGlow" />

          <div className="account__menu-heading">
            <div className="account__menu-heading-avatarWrap">
              <img
                className="account__menu-heading-avatar"
                src={userData?.avatar}
                alt="no file"
                onError={(event) => {
                  event.target.onerror = null;
                  event.target.src = noFile;
                }}
              />
              <span className="account__menu-heading-status" />
            </div>

            <div className="account__menu-heading-tag">
              <label className="account__menu-heading-tag-label">
                Хэрэглэгчийн нэр
              </label>
              <p className="account__menu-heading-tag-text">{getUserName()}</p>

              <label className="account__menu-heading-tag-label">
                Эрхийн төрөл
              </label>
              <div className="account__menu-heading-rolePill">
                {getUserRole() || "Тодорхойгүй"}
              </div>
            </div>
          </div>

          {renderMenu()}
        </aside>

        <main className="account__content">
          <div className="account__content-card">
            <Routes>
              <Route path="/" element={<Navigate to="/account/profile" />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/my-courses" element={<MyCourses />} />
              <Route path="/my-exams" element={<MyExams />} />
              <Route path="/order-history" element={<MyOrderHistory />} />
            </Routes>
          </div>
        </main>
      </div>
    </Layout>
  );
};

export default Account;
